import {ACTION} from './constants';
import request from '../../../../../utils/request';
import {requestConfig} from "../../../../../config/apiResource";
import {hideMainLoader,showMainLoader} from "../../../../actions";
import {formDataGenerator} from "../../../../../utils/common";

export function getSchemeContent(serverData,nodeTitle) {
    if(serverData.url){
        let urlArray=serverData.url.split('/');
        nodeTitle = urlArray[urlArray.length-1];
    }
    return dispatch => {
        dispatch(showMainLoader());
        return request(requestConfig.getSchemeDetail(nodeTitle))
            .then((json) => {
                dispatch(hideMainLoader());
                json && dispatch({ type: ACTION.GET_SCHEME_CONTENT, data: json.data });
                return json;
            }).catch((error) => {
                dispatch(hideMainLoader());
                console.log("Got Error with Scheme data: " + error)
            });
    }
}

export function getProductPerformanceTabContent(lang,nodeId) {
    return dispatch => {
        return request(requestConfig.getProductPerformanceTabContent(lang,nodeId))
            .then((json) => {
                json && dispatch({ type: ACTION.GET_PERFORMANCE_TAB_CONTENT, data: json.data });
            }).catch((error) => {
                console.log("Got Error with Product performance data: " + error)
            });
    }
}

export function getProductFundFactTabContent(lang,nodeId) {
    return dispatch => {
        return request(requestConfig.getProductFundFactTabContent(lang,nodeId))
            .then((json) => {
                json && dispatch({ type: ACTION.GET_FUNDFACTS_TAB_CONTENT, data: json.data });
            }).catch((error) => {
                console.log("Got Error with product fund fact data: " + error)
            });
    }
}

export function getProductFundFactNavContent(lang,nodeId) {
    let is_fund_facts = !!nodeId.includes('gold-exchange-traded-fund')
    return dispatch => {
        return request(requestConfig.getProductFundFactNavContent(lang,nodeId, formDataGenerator({is_fund_facts})))
            .then((json) => {
                json && dispatch({ type: ACTION.GET_FUNDFACTS_TAB_NAV_CONTENT, data: json.data });
            }).catch((error) => {
                console.log("Got Error with product fund fact NAV data: " + error)
            });
    }
}

export function getProductDownloadTabContent(lang,nodeId) {
    return dispatch => {
        return request(requestConfig.getProductDownloadTabContent(lang,nodeId))
            .then((json) => {
                json && dispatch({ type: ACTION.GET_DOWNLOAD_TAB_CONTENT, data: json.data });
            }).catch((error) => {
                console.log("Got Error with product download data: " + error)
            });
    }
}

export function getOtherManagedFunds(lang,managerId) {
    return dispatch => {
        return request(requestConfig.getOtherManagedFunds(lang,managerId))
            .then((json) => {
                json && dispatch({ type: ACTION.GET_OTHER_MANAGED_FUNDS, data: json.data });
            }).catch((error) => {
                console.log("Got Error with other managed funds data: " + error)
            });
    }
}

export function getInvestorViewed(lang) {
    return dispatch => {
        return request(requestConfig.getInvestorViewed(lang))
            .then((json) => {
                json && dispatch({ type: ACTION.GET_INVESTOR_VIEWED, data: json.data });
            }).catch((error) => {
                console.log("Got Error with other investor viewed data: " + error)
            });
    }
}

export function getMinAmtdetailData(schemeCode) {
    return dispatch => {
        return request(requestConfig.getMinimumAmounttDetail(schemeCode))
            .then((json) => {
                json && dispatch({ type: ACTION.GET_MIN_AMT_DETAIL, data: json.data });
            }).catch((error) => {
                console.log("Got Error with GET_MIN_AMT_DETAIL data: " + error)
            });
    }
}


export function clearSchemeContent() {
    return { type: ACTION.CLEAR_SCHEME_CONTENT }
}
